var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _vm._l(_vm.showData, function (notification) {
          return [
            _c(notification.component, {
              tag: "component",
              attrs: { data: notification },
            }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }